import React from 'react';

export const MineIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
			<circle cx="15" cy="15" r="14" fill="white" stroke="#FBDD3D" stroke-width="2" />
			<svg xmlns="http://www.w3.org/2000/svg" width="31" height="43" viewBox="0 0 28 12" fill="none">
				<path d="M7.5 10.5L11 12H13.5H16.5L21 10.5L25 7L27 3.5L28 0.5C16.9422 5.17668 10.8038 5.47098 0 0.5L1 3L2.5 6L4.5 8.5L7.5 10.5Z" fill="#FBDD3D" />
			</svg>
		</svg>
	);
};
